/**
 * Maps backend font names to user-friendly display names.
 * Use this function whenever displaying font names to users.
 * @param {Object} params - Parameters for font display name mapping.
 * @param {string} params.fontName - The backend font name.
 * @returns {string} The display name for the font.
 */
export function getFontDisplayName({ fontName }) {
  if (!fontName || typeof fontName !== 'string') {
    return fontName || '';
  }

  // Map backend font names to display names.
  const fontDisplayMap = {
    'Pizza Is My Favorite': 'Handwritten Child Style'
  };

  return fontDisplayMap[fontName] || fontName;
}
